/* OPERATIONS = REDUX THUNKS

This file defines the public interface of the duck -- what can be dispatched from components
Simple operations are just about forwarding an action creator, ex: simpleQuack
Complex operations involve returning a thunk that dispatches multiple actions in a certain order, ex: complexQuack

*/

import * as actions from './actions';
import store from '../store';
import surchxApi from '../../utils/api/surchx_base_api';
import {axios_without_interceptors as surchxWithoutInterceptorsApi} from '../../utils/api/surchx_base_api';

import surchxApiTest from '../../utils/api/surchx_base_api-test';
import { nullToBlank } from '../../utils/validations';
import { SurchxStatus } from '../../utils/constant';
import { checkToken, getTemporaryToken } from '../../utils/token-utils';

const editMerchantOp = data => async dispatch => {
    try {
        const response = await dispatch(actions.editMerchant(data));

        dispatch(
            actions.setMerchant(nullToBlank(response.value.data.merchant))
        );

        return response;
    } catch (error) {
        throw error;
    }
};

const getMerchantOp = data => async dispatch => {
    try {
        const response = await dispatch(actions.getMerchant(data));

        dispatch(
            actions.setMerchant(nullToBlank(response.value.data.merchant))
        );

        return response;
    } catch (error) {
        throw error;
    }
};

const getMerchantReportsData = data => async () => {
    const { interceptors=true } = data;
    const state = store.getState();

    const { siteMode } = state.userReducer.user;
    const {
        merchant_id,
        merchant_id_test,
        surcharge_active,
    } = state.merchantReducer.merchant;
    const { bearerToken, bearerTokenTest } = state.tokenReducer.tokens;

    let txStatus = '?';

    if (surcharge_active) {
        SurchxStatus.ACTIVE.map(
            status => (txStatus += `&surchxStatus=${status}`)
        );
    } else {
        SurchxStatus.INACTIVE.map(
            status => (txStatus += `&surchxStatus=${status}`)
        );
    }

    // month transactions
    try {
        let monthUrl;
        let month;

        if (siteMode && merchant_id) {
            month = await checkToken(bearerToken, siteMode).then(
                async bearerToken => {
                    const config = {
                        headers: {
                            Authorization: `Bearer ${bearerToken}`,
                            'X-Requested-With': 'xhr',
                        },
                    };

                    monthUrl = `/merchant/${merchant_id}/txlog/summary/month${txStatus}`;

                    if(interceptors){
                        const month1 = await surchxApi(monthUrl, config);
                        return month1;
                    }else{
                        const month1 = await surchxWithoutInterceptorsApi(monthUrl, config);
                        return month1;
                    }
                }
            );
        } else if (!siteMode && merchant_id_test) {
            month = await checkToken(bearerTokenTest, siteMode).then(
                async bearerToken => {
                    const config = {
                        headers: {
                            Authorization: `Bearer ${bearerToken}`,
                            'X-Requested-With': 'xhr',
                        },
                    };

                    monthUrl = `/merchant/${merchant_id_test}/txlog/summary/month${txStatus}`;
                    const month2 = await surchxApiTest.get(monthUrl, config);

                    return month2;
                }
            );
        }
        return month;
    } catch (error) {
        throw error;
    }
};

const getMerchantSummaryData = data => async () => {
    const { startDate, endDate, mid = '', txStatus = ['Captured','Completed'], interceptors=true } = data;
    const state = store.getState();

    const { siteMode } = state.userReducer.user;
    const {
        merchant_id,
        merchant_id_test,
        surcharge_active,
    } = state.merchantReducer.merchant;
    const { bearerToken, bearerTokenTest } = state.tokenReducer.tokens;

    let surchxStatus = '';
    let use_mid = '';
    let theToken = '';
    let transactionTypes = '';

    if (surcharge_active) {
        SurchxStatus.ACTIVE.map(
            status => (surchxStatus += `&surchxStatus=${status}`)
        );
    } else {
        SurchxStatus.INACTIVE.map(
            status => (surchxStatus += `&surchxStatus=${status}`)
        );
    }
    
    try {
    
        if (mid !== '') {
            use_mid = mid;
            theToken = await getTemporaryToken(
                siteMode,
                use_mid,
            );
        } else {
            if (siteMode) {
                use_mid = merchant_id;
            } else {
                use_mid = merchant_id_test;
            }
        }

        txStatus.map(transactionType => {
            transactionTypes += `&status=${transactionType}`;
        });

        let dbUrl;
        let dbData;

        const start = startDate.format('YYYY-MM-DDT00:00:00-00:00');
        const end = endDate.format('YYYY-MM-DDT23:59:59-00:00');

        if (siteMode && merchant_id) {
            
            dbData = await checkToken(bearerToken, siteMode).then(
                async bearerToken => {
                    const config = {
                        headers: {
                            Authorization:
                                mid !== ''
                                    ? `Bearer ${theToken}`
                                    : `Bearer ${bearerToken}`,
                            'X-Requested-With': 'xhr',
                        },
                    };
                    dbUrl = `/merchant/${use_mid}/txlog/summary/period?start=${start}&end=${end}${surchxStatus}${transactionTypes}`;
                    
                    if(interceptors){
                        const dbData = await surchxApi(dbUrl, config);
                        return dbData;
                    }else{
                        const dbData = await surchxWithoutInterceptorsApi(dbUrl, config);
                        return dbData;
                    }
                }
            );

        } else if (!siteMode && merchant_id_test) {
            dbData = await checkToken(bearerTokenTest, siteMode).then(
                async bearerToken => {
                    const config = {
                        headers: {
                            Authorization:
                                mid !== ''
                                    ? `Bearer ${theToken}`
                                    : `Bearer ${bearerToken}`,
                            'X-Requested-With': 'xhr',
                        },
                    };
                    dbUrl = `/merchant/${use_mid}/txlog/summary/period?start=${start}&end=${end}${surchxStatus}${transactionTypes}`;
                    const dbData = await surchxApiTest(dbUrl, config);
                    return dbData;
                }
            );
        }
        return dbData;
    } catch (error) {
        throw error;
    }
};

export {
    editMerchantOp,
    getMerchantOp,
    getMerchantReportsData,
    getMerchantSummaryData,
};



// WEBPACK FOOTER //
// ./src/redux/merchant/operations.js